import React, { useEffect } from "react";

import classNames from "classnames";

import { Typography } from "clearsense-ui/components";

import { DESCRIPTION_KEYS } from "./constants";

const DetailedDescription = ({ description, activeTab }) => {
  useEffect(() => {
    if (activeTab.id) {
      const element = document.getElementById(activeTab.id);
      element.scrollIntoView({ behavior: "smooth" });
    }
  }, [activeTab]);

  const getConstraints = element =>
    element?.["constraint"]?.map(constraint => (
      <>
        <Typography
          style="medium"
          className="font-bold"
        >{`${constraint["key"]}:`}</Typography>
        <Typography style="medium">{`${constraint["human"]} (${constraint["expression"]})`}</Typography>
      </>
    ));

  const getDescriptionValues = (element, key) => {
    const descriptionValues = {
      definition: element?.[key] || "-",
      comment: element?.[key] || "-",
      type: element?.[key]?.[0]?.["code"] || "-",
      constraint: getConstraints(element, key) || "-",
      alias: element["alias"]?.join(", ") || "-",
      control: `${element.min}..${element.max}`,
    };

    return descriptionValues[key];
  };

  return (
    <div className="space-y-4">
      {description?.snapshot?.element?.map((element, index) => (
        <div
          key={index}
          id={element.id}
          className={classNames(
            "border-gray-300 shadow-sm hover:shadow group relative rounded-sm border p-4 transition-shadow duration-300 ease-in-out",
            {
              highlight: activeTab.id === element.id,
              "bg-white dark:bg-cs-ui-gray-800": activeTab.id !== element.id,
            }
          )}
        >
          <Typography
            style="h4"
            className="w-full text-indigo-700 dark:text-primary-lighter font-semibold"
          >
            {element.id}
          </Typography>
          {DESCRIPTION_KEYS.map((key, index) => (
            <div
              key={index}
              className="flex space-x-5 w-full mt-2 dark:text-shade-light"
            >
              <Typography style="medium" className="font-bold w-1/12">
                {key.label}
              </Typography>
              <Typography style="medium" className="w-4/5">
                {getDescriptionValues(element, key.value)}
              </Typography>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};
export default DetailedDescription;
